import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useWindowWidth } from '@nike/nike-design-system-components';

import OrderDeadlines from '../../orderDeadlines/OrderDeadlines';
import Carousel from '../../components/Carousel';
import LoadingAnimation from '../../components/LoadingAnimation';

import { getUserAccount } from '../selectors';
import { getSalesOrg } from '../../gamedayAccount/selectors';
import { deadlinesForAccount } from '../../orderDeadlines/reducer';
import { getOrderDeadlinesForAccount, selectDeadline } from '../../orderDeadlines/actions';

// import { isUSSalesOrg } from '../../util/constants';

const MAX_ORDER_WINDOWS = 3;

export const HomePageCarousel = () => {
  const dispatch = useDispatch();
  const salesOrg = useSelector(getSalesOrg);

  const [slides, setSlides] = useState([]);
  // const [carouselHeight, setCarouselHeight] = useState({ smallScreen: '680px', largeScreen: '502px' });

  // const isUSAccount = isUSSalesOrg(salesOrg);
  const userAccount = useSelector(getUserAccount);
  const deadlines = userAccount?.number
    ? useSelector(state => deadlinesForAccount(state, userAccount.number))
    : undefined;

  useEffect(() => {
    const deadlinesHaveLoaded = deadlines !== undefined;
    if (userAccount?.number && !deadlinesHaveLoaded) {
      dispatch(getOrderDeadlinesForAccount({ accountNumber: userAccount.number, limit: MAX_ORDER_WINDOWS }));
    }
    if (deadlines) {
      dispatch(selectDeadline(deadlines[0]));
    }
    if (deadlinesHaveLoaded && deadlines) {
      setSlides([<OrderDeadlines />]);
    } else if (!deadlinesHaveLoaded) {
      setSlides([<LoadingAnimation size='s' />]);
    } else {
      setSlides([]);
    }
  }, [userAccount, deadlines, salesOrg]);

  const height = useWindowWidth() < 1165 ? '400px' : '350px';

  return <Carousel height={height} slides={slides} timePerSlide={10000} />;
};

export default HomePageCarousel;
